import { useEffect, useState } from 'react';
import type { BackofficeUserType } from '@/backoffice/config/theme';
import { fetchAdminDashboard } from '@/domains/admin/services/admin.service';

export interface AdminNavBadges {
  users?: number;
  disputes?: number;
  documents?: number;
  support?: number;
  communication?: number;
}

export function useAdminNavBadges(userType: BackofficeUserType): AdminNavBadges {
  const [badges, setBadges] = useState<AdminNavBadges>({});

  useEffect(() => {
    if (userType !== 'admin' && userType !== 'super_admin') return;

    fetchAdminDashboard(userType === 'super_admin')
      .then((data) => {
        const s = data.stats;
        setBadges({
          users: s.pending_users > 0 ? s.pending_users : undefined,
          disputes: s.open_disputes > 0 ? s.open_disputes : undefined,
          documents: s.pending_documents > 0 ? s.pending_documents : undefined,
          support: s.open_support_requests > 0 ? s.open_support_requests : undefined,
        });
      })
      .catch(() => setBadges({}));
  }, [userType]);

  return badges;
}
